function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.187 18.234L19.817 30 23 26.752 11.383 15 23 3.248 19.817 0 8.187 11.766l-.004-.004-.791.808L5 14.99l.01.01-.01.01 2.392 2.42.791.808.004-.004z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "5",
  y: "0",
  width: "18",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.187 18.234L19.817 30 23 26.752 11.383 15 23 3.248 19.817 0 8.187 11.766l-.004-.004-.791.808L5 14.99l.01.01-.01.01 2.392 2.42.791.808.004-.004z",
  fill: "currentColor"
}))));